// extracted by mini-css-extract-plugin
module.exports = {"authMethodsList":"_1Dxni"};